import { distance } from "@turf/distance";
import type { LngLat } from "./types.ts";

const METERS_PER_KILOMETER = 1_000;
const MAX_DISPLAY_DISTANCE_METERS = 100 * METERS_PER_KILOMETER;

export function distanceMeters(from: LngLat, to: LngLat): number {
  return distance([...from], [...to], { units: "meters" });
}

// Intl.NumberFormat localizes the chosen unit, but current browser Intl APIs
// do not expose a reliable measurement-system preference. Keep metric as app
// policy for now; a future explicit user preference can replace this function.
export function formatMetricDistance(meters: number): string | undefined {
  if (meters > MAX_DISPLAY_DISTANCE_METERS) {
    return undefined;
  }

  if (meters < 50) {
    return "< 50 m";
  }

  if (meters < METERS_PER_KILOMETER) {
    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 0,
      style: "unit",
      unit: "meter",
      unitDisplay: "short",
    }).format(roundToNearest(meters, 10));
  }

  const kilometers = meters / METERS_PER_KILOMETER;

  return new Intl.NumberFormat(undefined, {
    maximumFractionDigits: kilometers < 10 ? 1 : 0,
    style: "unit",
    unit: "kilometer",
    unitDisplay: "short",
  }).format(kilometers);
}

function roundToNearest(value: number, interval: number): number {
  return Math.round(value / interval) * interval;
}
